import { BudgetItem } from '../../entities/Budget'
import { apiRequest } from '../client'

export interface FetchBudgetPayload {
  costItemStickerIds: string[]
}

export const fetchBudget = async (
  objectId: string,
  payload: FetchBudgetPayload
): Promise<BudgetItem> => {
  const response = await apiRequest(`/budgets/${objectId}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })

  if (response.status === 400) {
    throw new Error('Некоректные параметры запроса')
  }

  if (response.status === 404) {
    throw new Error('Данные бюджета для указанного объекта и статьи не найдены')
  }

  if (!response.ok) {
    throw new Error('Не удалось загрузить данные по бюджету')
  }

  return (await response.json()) as BudgetItem
}
